<template>
  <aside class="hidden lg:block lg:w-60 flex-shrink-0">
    <nav class="lg:sticky card p-3" style="top: 5.5rem">
      <p class="text-xs font-bold uppercase tracking-wider text-ink-muted px-3 pt-2 pb-3">
        Menu
      </p>
      <div class="space-y-1">
        <router-link
          v-for="link in links"
          :key="link.title"
          :to="{ name: link.routeName }"
          active-class="is-active"
          class="menu-link group flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold transition-colors text-ink-soft hover:bg-gray-50"
        >
          <font-awesome-icon :icon="link.icon" class="menu-ico w-4 text-center text-ink-muted" />
          <span>{{ link.title }}</span>
        </router-link>
      </div>
    </nav>
  </aside>
</template>

<script>
export default {
  data() {
    return {
      links: [
        { title: 'Dashboard', routeName: 'Dashboard', icon: 'chart-line' },
        { title: 'Score new sample', routeName: 'Score', icon: 'upload' },
        { title: 'Measurements', routeName: 'Measurements', icon: 'vials' },
        { title: 'Device suitability', routeName: 'Suitability', icon: 'tasks' },
      ],
    }
  },
}
</script>

<style scoped>
.menu-link:hover,
.menu-link:hover .menu-ico {
  color: #831f82;
}
.menu-link.is-active {
  background-color: #fbf4fb;
  color: #831f82;
}
.menu-link.is-active .menu-ico {
  color: #831f82;
}
</style>
